var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavedown3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1700 140",
    width: 1700,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 81L35.5 83.5C71 86 142 91 212.8 90C283.7 89 354.3 82 425.2 73C496 64 567 53 637.8 52C708.7 51 779.3 60 850.2 69.3C921 78.7 992 88.3 1062.8 83.7C1133.7 79 1204.3 60 1275.2 61.5C1346 63 1417 85 1487.8 91.8C1558.7 98.7 1629.3 90.3 1664.7 86.2L1700 82L1700 141L1664.7 141C1629.3 141 1558.7 141 1487.8 141C1417 141 1346 141 1275.2 141C1204.3 141 1133.7 141 1062.8 141C992 141 921 141 850.2 141C779.3 141 708.7 141 637.8 141C567 141 496 141 425.2 141C354.3 141 283.7 141 212.8 141C142 141 71 141 35.5 141L0 141Z",
    fill: "#0028a6",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavedown3);
export default __webpack_public_path__ + "static/media/wavedown3.4c89692ac0600f967556be4c89eaccaa.svg";
export { ForwardRef as ReactComponent };